import { MyRatings } from "@app/shared/models/myRatingsModel";

export class AnalystPublicProfileModel {
    biography: string;
    code: string;
    contactNumbers: any;
    email: string;
    firstName: string;
    followerCount: number;
    id: string;
    isActive: boolean;
    isFollow: boolean;
    jobTitle: any;
    lastName: string;
    lineOfBusiness: any;
    middleName: any;
    myRatings: any = new MyRatings();
    name: string;
    nickName: string;
    organizationName: string;
    ratings: any;
    reports: any;
    salutationName: string;
}




// WEBPACK FOOTER //
// ./src/app/shared/models/analystPublicProfileModel.ts